"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupChatMessageReadObservable = void 0;
const Observable_1 = require("../../socket/Observable");
const DomainEvents_1 = require("../../utils/DomainEvents");
class GroupChatMessageReadObservable {
    constructor(chatsStorage, organizationUser) {
        this.chatsStorage = chatsStorage;
        this.organization = organizationUser.getOrganization();
    }
    chatMessageReadListener(cb, chatType, groupType) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getChatLogUpdateKey)(this.organization.organizationId, chatType, groupType), (data) => __awaiter(this, void 0, void 0, function* () {
            if (data.lastMessage) {
                this.chatsStorage.updateChat(data.lastMessage.to, groupType, {
                    lastMessageRead: data.lastMessageRead,
                    unreadCount: data.unreadCount,
                    hasPriorityMessage: false,
                }, data.unreadCount);
                cb(this.chatsStorage.getChatListByType(groupType));
            }
        }));
    }
}
exports.GroupChatMessageReadObservable = GroupChatMessageReadObservable;
